module.exports = __webpack_public_path__ + "img/invoice-de-male-banner-bb.7c6a386e.png";